module.exports = {

  /**
   * 顶栏是否固定
   */
  fixedHeader: false,

  /**
   * 是否展开侧边栏logo
   */
  sidebarLogo: true,

  /**
   * 是否开启图钉
   */
  tagsView: true
}
